type tabsProps = {
  tabListSelector: string
  tabSelector: string
  panelsSelector: string
  inactiveTabClasses: string[]
  activeTabClasses: string[]
  tabsBelowContent: boolean
}

export default function tabs(el: HTMLElement, props: tabsProps) {
  const tabListEl: HTMLElement | null = el.querySelector(props.tabListSelector)
  const tabEls: NodeListOf<HTMLButtonElement> = el.querySelectorAll(
    props.tabSelector
  )
  const panelsEl: HTMLElement | null = el.querySelector(props.panelsSelector)
  const inactiveTabClasses = props.inactiveTabClasses
  const activeTabClasses = props.activeTabClasses
  const tabsBelowContent = props.tabsBelowContent

  if (
    tabListEl == null ||
    tabEls == null ||
    panelsEl == null ||
    inactiveTabClasses == null ||
    activeTabClasses == null ||
    tabsBelowContent == null
  ) {
    return
  }

  tabEls.forEach(tab => {
    tab.addEventListener("click", function (e) {
      changeTabs(e, panelsEl, inactiveTabClasses, activeTabClasses)
    })
  })

  let tabFocus = 0

  tabListEl.addEventListener("keydown", e => {
    if (e.keyCode === 39 || e.keyCode === 37) {
      tabEls[tabFocus].setAttribute("tabindex", "-1")
      if (e.keyCode === 39) {
        tabFocus++
        if (tabFocus >= tabEls.length) {
          tabFocus = 0
        }
      } else if (e.keyCode === 37) {
        tabFocus--
        if (tabFocus < 0) {
          tabFocus = tabEls.length - 1
        }
      }
      tabEls[tabFocus].setAttribute("tabindex", "0")
      tabEls[tabFocus].focus()
    } else if (e.keyCode === 38 && tabsBelowContent === true) {
      let activePanel: HTMLElement | null = panelsEl.querySelector(
        "[role=tabpanel]:not([hidden=true])"
      )
      if (activePanel == null) {
        return
      }
      activePanel.focus()
    }
  })
}

function changeTabs(
  e: MouseEvent,
  panelsEl: HTMLElement,
  inactiveTabClasses: string[],
  activeTabClasses: string[]
) {
  const target: HTMLElement | null = e.currentTarget as HTMLElement
  const parent: HTMLElement | null = target.parentElement

  if (target == null || parent == null) {
    return
  }

  const activeTabs: NodeListOf<HTMLElement> = parent.querySelectorAll(
    '[aria-selected="true"]'
  )
  if (activeTabs == null) {
    return
  }
  activeTabs.forEach(el => {
    el.setAttribute("aria-selected", "false"),
      el.classList.remove(...activeTabClasses),
      el.classList.add(...inactiveTabClasses)
  })

  target.setAttribute("aria-selected", "true")
  target.classList.remove(...inactiveTabClasses)
  target.classList.add(...activeTabClasses)

  const panelEls: NodeListOf<HTMLElement> = panelsEl.querySelectorAll(
    '[role="tabpanel"]'
  )
  const panelElsParentEl: HTMLElement | null = panelsEl.parentElement
  if (panelEls == null || panelElsParentEl == null) {
    return
  }

  panelEls.forEach(el => {
    el.setAttribute("hidden", "true"),
      el.classList.remove("ca:block"),
      el.classList.add("ca:hidden")
  })

  let activePanel: HTMLElement | null = panelElsParentEl.querySelector(
    `#${target.getAttribute("aria-controls")}`
  )
  if (activePanel == null) {
    return
  }
  activePanel.removeAttribute("hidden")
  activePanel.classList.remove("ca:hidden")
  activePanel.classList.add("ca:block")
}
